import Button from "../../common/components/Button";
import React from "react";
export default function FilterFooter({ offersCount, loading, onSubmit, }) {
    return (<div className="shrink-0 p-4 bg-white">
      <Button type="button" onClick={onSubmit} disabled={loading} className={"w-full"}>
        {loading ? "Ładowanie…" : `Pokaż oferty (${offersCount})`}
      </Button>
    </div>);
}
